export const make3 = (name) => [`${name}_REQUEST`, `${name}_SUCCESS`, `${name}_FAIL`];

export const type3 = (name) => make3(name).map((key) => types[key]);

const promiseTypes = [
  'LOAD_GALLERY',
  'LOAD_UNTAGGED',
  'LOAD_GALLERY_PHOTO',
  'LOAD_CATEGORIES',
  'LOAD_SETTINGS',
].reduce((prev, cur) => {
  make3(cur).forEach((key) => {
    prev[key] = key;
  });

  return prev;
}, {});

const simpleTypes = [
  'SET_ROUTE',
  'SET_HEADER',
  'SET_USER_DATA',
  'SET_ORDER_FORM_DATA',
  'PUSH_TO_INTERNAL_STACK',
  'POP_FROM_INTERNAL_STACK',
  'CLEAR_INTERNAL_STACK',
  'CLEAR_APP_DATA',
  'SET_LOADING'
].reduce((prev, cur) => {
  prev[cur] = cur;
  return prev;
}, {});

export const types = { ...simpleTypes, ...promiseTypes };
